import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// 引入全局样式文件
import "@/assets/css/common.css";
import "@/assets/css/font.css";
Vue.config.productionTip = false;
// 图片地址前缀
Vue.prototype.$baseUrl = "https://media.qyskills.com/official-website";
Vue.prototype.$getImageUrl = (path) => `${Vue.prototype.$baseUrl}${path}`;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
